import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { createPermissionAdmin, editPermissionAdmin, getPermissionsAdmin,
searchPermissionsAdmin, deletePermissionAdmin } from '../../actions/permissionsAction'
import { Translate } from '../../../language';
import searchIcon from '../../../img/ic__buscador.png'
import inMemoryJWT from '../../../auth/inMemoryJwt';

const PermissionGlobalAdmin = ({ history, searchPermissionsAdmin, createPermissionAdmin, isLoadinglistPermissionAdmin, getPermissionsAdmin, deletePermissionAdmin, editPermissionAdmin, listPermissionAdmin }) => {

    useEffect(() => {
        if(!(inMemoryJWT.getToken())){
            inMemoryJWT.getRefreshedToken()
        }

        inMemoryJWT.waitForTokenRefresh().then(() => {
            getPermissionsAdmin()
        })
        
    },[])
   

    const [isEdit, setIsEdit] = useState(false)
    const [idEdit, setIdEdit] = useState('')
    const [indexEdit, setIndexEdit] = useState('')
    const [namePermission, setNamePermission] = useState('')
    const [codePermission, setCodePermission] = useState('')
    const [description, setDescription] = useState('')
    const [search, setSearch] = useState('')
    const [isEnable, setEnable] = useState(false)
    const [isValidate, setValidate] = useState(false)
    const [error, setError] = useState({})


    

    const isFocused = (e) => {
        const { name } = e.target;
        setError(prevError => ({
            ...prevError,
            [name]: ''
        }));
    }

    const isEmpty = (e) => {
        if (namePermission !== '' && description !== '' && codePermission !== '') {
            setValidate(true)
        }
        const { name, placeholder, value } = e.target;
        if (value.length === 0) {
            setValidate(false)
            setError(prevError => ({
                ...prevError,
                [name]: Translate('missingField', 'es') + placeholder
            }));
        }
        if (value.length !== 0) {

            setError(prevError => ({
                ...prevError,
                [name]: ''
            }));
        }

    }


    return (
        <div className="container-mark-type-admin">
            <div className="new-edit-type-mark-container-admin">
                <div className='title-admin'>{`${isEdit ? 'Editar' : 'Nuevo'} permiso`}</div>
                <div className="container-inputs-new-mark">
                    <div className="text-input-admin">
                        {'Nombre:'}
                    </div>
                    <input
                        name='namePermission'
                        className='inputs-admin'
                        value={namePermission}
                        onChange={(e) => {
                            setNamePermission(e.target.value.trimStart())
                            if (namePermission !== '' && description !== '' && codePermission !== '') {
                                setValidate(true)
                            }
                        }}
                        onBlur={e => isEmpty(e)}
                        onFocus={e => isFocused(e)}
                        onKeyUp={e => isEmpty(e)}                        
                    />
                    <div className="text-error text-error-admin">{error.name}</div>
                    <div className="text-input-admin">
                        {'Código:'}
                    </div>
                    <input
                        name='codePermission'
                        className='inputs-admin'
                        value={codePermission}
                        onChange={(e) => {
                            setCodePermission(e.target.value.trimStart())
                            if (namePermission !== '' && description !== '' && codePermission !== '') {
                                setValidate(true)
                            }
                        }}
                        onBlur={e => isEmpty(e)}
                        onFocus={e => isFocused(e)}
                        onKeyUp={e => isEmpty(e)}
                    />
                    <div className="text-error text-error-admin">{error.codePermission}</div>
                    <div className="text-input-admin">
                        {'Descripción:'}
                    </div>
                    <input
                        name='description'
                        className='inputs-admin'
                        value={description}
                        onChange={(e) => {
                            setDescription(e.target.value.trimStart())
                            if (namePermission !== '' && description !== '' && codePermission !== '') {
                                setValidate(true)
                            }
                        }}
                        onBlur={e => isEmpty(e)}
                        onFocus={e => isFocused(e)}
                        onKeyUp={e => isEmpty(e)}
                    />
                    <div className="text-error text-error-admin">{error.description}</div>
                    {isEdit ?
                        <div className="content-buttom-create-admin">
                            <button className={`btns-admin btn-create-edit btns-admin-inactive`} onClick={() => {
                                setNamePermission('')
                                setDescription('')
                                setCodePermission('')
                                setEnable(false)
                                setIdEdit('')
                                setIndexEdit('')
                                setIsEdit(false)
                            }}>
                                {Translate('cancel', 'es')}
                            </button>
                            <div className="ml-1 mr-1"></div>
                            <button disabled={isValidate ? '' : 'disabled'}
                                className={`btns-admin btn-create-edit ${isValidate ? '' : 'btns-admin-inactive'}`} onClick={() => {
                                    editPermissionAdmin({ name: namePermission.trim(), description: description.trim(), permissionId: idEdit, code: codePermission }, history, indexEdit)
                                    setNamePermission('')
                                    setCodePermission('')
                                    setDescription('')
                                    setEnable(false)
                                    setIdEdit('')
                                    setIndexEdit('')
                                    setIsEdit(false)
                                }}>
                                {Translate('edit', 'es')}
                            </button>
                        </div>

                        :
                        <div className="content-buttom-create-admin">
                            <button disabled={isValidate ? '' : 'disabled'}
                                className={`btns-admin btn-create-edit ${isValidate ? '' : 'btns-admin-inactive'}`} onClick={() => { createPermissionAdmin({ name: namePermission.trim(), description: description.trim(), code: codePermission.trim() }, history) }}>
                                {Translate('create', 'es')}
                            </button>
                        </div>

                    }
                </div>
            </div>
            <div className="see-all-mark-type-admin">
                <div className='title-admin-list'>Permisos </div>
                <div className="search-bar-navbar search-bar-admin">
                    <input
                        autoComplete="off"
                        className="input-inside-div"
                        name="categorie"
                        type="text"
                        value={search}
                        onChange={(e) => {
                            setSearch(e.target.value.trimStart())
                            searchPermissionsAdmin({ search: e.target.value.trimStart() })
                        }}
                    />
                    <img src={searchIcon} alt="img" className="img-search-bar-right" />
                </div>
                <div className='wrapper-2 column-gap row-gap mt-3'>
                    {isLoadinglistPermissionAdmin ? <div>Cargando...</div> :
                        listPermissionAdmin.map((permission, index) => (
                            <div key={permission._id} className="mb-2 row mr-3 ml-2 card-admin">
                                <div className="tittle-card-admin">{permission.code}</div>
                                <div className="text-content-card">{permission.name}</div>
                                <div className="text-content-card">{permission.description}</div>
                                <div className="column centerContent">
                                    <div className="btns-admin ml-1 mr-1" onClick={() => {
                                        setNamePermission(permission.name)
                                        setDescription(permission.description)
                                        setCodePermission(permission.code)
                                        setEnable(permission.isEnable)
                                        setIdEdit(permission._id)
                                        setIndexEdit(index)
                                        setIsEdit(true)
                                    }}>Editar</div>
                                    <div className="btns-admin btns-admin-red" onClick={() => { deletePermissionAdmin(permission._id, index) }}>Eliminar</div>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        isLoadinglistPermissionAdmin: state.permissionsAdmin.isLoadinglistPermissionAdmin,
        listPermissionAdmin: state.permissionsAdmin.listPermissionAdmin
    }
}

export default connect(mapStateToProps, { createPermissionAdmin, searchPermissionsAdmin, editPermissionAdmin, getPermissionsAdmin, deletePermissionAdmin })(PermissionGlobalAdmin)